/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpResponse, HttpContext, HttpParams } from '@angular/common/http';
import { DataBaseService } from '../data-base-service';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { MyDelegationsDto } from '../models/my-delegations-dto';

@Injectable({ providedIn: 'root' })
export class DelegationsControllerService extends DataBaseService {

  /**
   * Path part for operation delegationsControllerGetActiveDelegations
   */
  static readonly DelegationsControllerGetActiveDelegationsPath = '/v1/delegations/my';

  /**
   * Returns my current active delegations
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getActiveDelegations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveDelegations$Response(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<Array<MyDelegationsDto>>> {

    const rb = new RequestBuilder(this.rootUrl, DelegationsControllerService.DelegationsControllerGetActiveDelegationsPath, 'get');
    if (params) {
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<MyDelegationsDto>>;
      })
    );
  }
  /**
   * Returns my current active delegations
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getActiveDelegations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getActiveDelegations(params?: {
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<Array<MyDelegationsDto>> {

    return this.getActiveDelegations$Response(params).pipe(
      map((r: StrictHttpResponse<Array<MyDelegationsDto>>) => r.body as Array<MyDelegationsDto>)
    );
  }

  /**
   * Path part for operation delegationsControllerGetDelegation
   */
  static readonly DelegationsControllerGetDelegationPath = '/v1/delegations/{id}';

  /**
   * Returns a delegation by id
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDelegation()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDelegation$Response(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<StrictHttpResponse<MyDelegationsDto>> {

    const rb = new RequestBuilder(this.rootUrl, DelegationsControllerService.DelegationsControllerGetDelegationPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.extraHttpParams(params.extraParams);
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: params?.context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<MyDelegationsDto>;
      })
    );
  }
  /**
   * Returns a delegation by id
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getDelegation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDelegation(params: {
    id: string;
    extraParams?: HttpParams,
    context?: HttpContext
  }): Observable<MyDelegationsDto> {

    return this.getDelegation$Response(params).pipe(
      map((r: StrictHttpResponse<MyDelegationsDto>) => r.body as MyDelegationsDto)
    );
  }

}
